// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Gp-z","imageAndVideoCount":"Hp-z","imageAndVideoContainer":"Ip-z","viewAllReviews":"Jp-z"};